import type { ReactNode } from 'react';
import type { Placement } from '@floating-ui/react';
import type { DotPosition, OffsetStyle } from '../types';
import { OnboardingHotspot } from './onboarding-hotspot';
import { OnboardingInfoTooltip } from './onboarding-info-tooltip';

interface OnboardingHotspotWithTooltipProps {
  target: string;
  enabled?: boolean;
  children: ReactNode;
  placement?: Placement;
  tooltipOffset?: number;
  position?: DotPosition;
  hotspotOffset?: OffsetStyle;
}

export function OnboardingHotspotWithTooltip({
  target,
  enabled = true,
  children,
  placement,
  tooltipOffset,
  position,
  hotspotOffset,
}: OnboardingHotspotWithTooltipProps) {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <OnboardingInfoTooltip target={target} placement={placement} offset={tooltipOffset}>
      <OnboardingHotspot target={target} position={position} offset={hotspotOffset}>
        {children}
      </OnboardingHotspot>
    </OnboardingInfoTooltip>
  );
}
